<template>
  <div>
    <div :class="_isMobile ? 'footer_wrap' : 'footer_pc'">
      <div class="content_top">
        <div class="content">
          <div class="content_top_box flex jusSpace">
            <div class="relationBox">
              <p class="title">联系我们</p>
              <p>邮箱：marketing@youjiajk.com</p>
              <p :class="_isMobile ? 'disFlex' : ''"><span>客服电话：400-898-1618</span> <span>合作咨询电话：010-65541371</span>
                <span>公司地址：北京市丰台区平安幸福中心A座19层1901</span></p>
            </div>
            <!-- <div class="app">
              <p class="title">更多精彩内容，请下载APP</p>
              <img src="../assets/image/appCode.png" alt="">
              <p>恬橙健康APP</p>
            </div> -->
          </div>
        </div>
      </div>
      <div class="content_bottom">
        <div class="content">
          <p class="style" :class="_isMobile ? 'disFlex' : ''">
            <span class="cursor" @click="goPage('medicalDevices')">药品医疗器械网络信息服务备案编号：(京)网药械信息备字(2022) 第 00366 号 </span>
            <span class="cursor"
              @click="goPage('medicalDevicesVoucher')">医疗器械网络交易服务第三方平台备案编号：(京)网械平台备字（2021）第00015号</span>
            <span class="cursor" @click="goPage('drugDevices')">药品网络交易服务第三方平台备案编号:(京)网药平台备字[2024]第000006号 </span>
            <span class="cursor" @click="goPage('internetFood')">网络食品交易第三方平台提供者备案信息表</span>
            <span>中华人民共和国增值电信业务经营许可证：合字B2-20210343</span>
          </p>
          <p class="style">
            <span>优加健保健康科技（北京）有限公司 版权所有 2015-2020</span>
            <img class="recordsIcon" src="../assets/image/recordsIcon.png" alt="" />
            <span class="register-system-info" @click="handleToBeiAn">京公网安备11010502050491号</span>
            <span class="cursor register-system-info" @click="goPage('out')"> 京ICP备17074952号</span>
          </p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        _isMobile: false,
        yjjkList: [{
          text: '公司介绍',
          href: 'about'
        }, {
          text: '公司荣誉',
          href: 'about'
        }, {
          text: '加入我们',
          href: 'contactus'
        }],
        yjtsList: [{
            text: '专属定制服务'
          },
          {
            text: '创新保险方案'
          }
        ],
        router: '',
        text: '联系我们'
      }
    },
    created() {
      this._isMobile = this.$util._isMobile()
      this.router = this.$router.history.current.path.slice(1)
      if (this.router === 'contactus') {
        this.text = '加入我们'
      } else {
        this.text = '联系我们'
      }
    },
    methods: {
      goPage(text) {
        if (text === 'out') {
          let href = 'https://beian.miit.gov.cn/'
          window.open(href, '_blank');
        } else {
          this.$router.push({
            name: text
          })
        }

      },

      // 跳转公安备案
      handleToBeiAn() {
        window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502050491', '_blank')
      }
    }
  }
</script>

<style scoped lang="less">
  .footer {
    width: 100%;
    background: #031323;

    .recordsInfo {
      font-size: 14px;
      color: #c5c5c5;
      width: 100%;
      text-align: center;
      margin-top: 63px;
      margin-bottom: 15px;


      span {
        &:first-child {
          margin-right: 10px;
        }
      }

      .records {
        margin-left: 10px;
        display: flex;
        align-items: center;

        span {
          margin-left: 2px;
        }
      }

    }

    .recordsInfo_wrap {
      font-size: 0.18rem;
      margin-top: 0.4rem;
      margin-bottom: 0.1rem;

      span {
        line-height: 0.3rem;

        &:first-child {
          margin-bottom: 0.1rem;
          display: inline-block;
        }
      }

      .records {
        justify-content: center;
      }
    }

    .recordsInfo_pc {
      display: flex;
      align-items: center;
      justify-content: center;

    }

    .footer_bottom {

      color: #c5c5c5;
      text-align: center;
      border-top: 1px solid #162c42;

      span {
        cursor: pointer;
      }
    }
  }


  .footer_wrap {
    width: 100%;
    background: #2A2A32;
    font-family: Source Han Sans CN, Source Han Sans CN-5;
    color: #FFFFFF;

    .footerImg {
      width: 100%;
      height: 9.14rem;
    }

    .footer_wrapper {
      padding: 0.25rem 0.15rem;
      color: #FFFFFF;

    }

    .footerFlex {
      padding: 0.8rem 0.74rem 0 !important;

      .itemFlex {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      }



      .moduleTitle {
        font-size: 0.24rem;
        font-weight: 500;
      }

      .moduleCon {
        opacity: 0.8;
        font-size: 0.22rem;

        .iconStyle {
          width: 0.08rem;
          height: 0.12rem;
          margin-right: 0.19rem;
        }

        .relationFlex {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex: 1;
          margin: 0.2rem 0.15rem;

          .iconStyle {
            width: 0.16rem;
            height: 0.16rem;
            margin-right: 0.19rem;
          }
        }

        .relationFlexCenter {
          align-items: flex-start;

          span {
            display: flex;
            flex-direction: column;
            line-height: 0.5rem;
          }

          .iconStyle {
            margin-top: 0.2rem;
          }
        }
      }

      .mrt40 {
        margin-top: 0.4rem;
      }

      .mr25 {
        margin: 0.39rem 0.15rem;
      }

      .codeBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1rem;

        img {
          width: 1.65rem;
          height: 1.65rem;

          &:last-child {
            margin-left: 0.2rem;
          }
        }
      }
    }

    .footerBottom_wrap {
      font-size: 0.18rem;
      padding: 0.3rem 0.4rem;
      // margin-top: 0.4rem;
    }

    .p3 {
      padding: 0 0.3rem;
    }

    .tal {
      p {
        font-size: 0.2rem;
      }

      text-align: center !important;

      img {
        width: 1.5rem;
        height: 1.5rem;
        margin-top: 0.2rem;
      }
    }

  }

  .curpoi {
    cursor: pointer;
  }

  .footer_pc {
    width: 100%;
    background: #2A2A32;
    font-family: Source Han Sans CN, Source Han Sans CN-5;

    .content {
      width: 1200px;
      margin: 0 auto;
      font-size: 18px;
      color: #FFFFFF;
    }

    .flex {
      display: flex;
    }

    .jusSpace {
      justify-content: space-between;
    }

    .content_top {
      padding: 26px 0;

      .relationBox {
        font-size: 14px;
        color: #949498;
        font-weight: 400;
        line-height: 21px;
        margin-top: 20px;

        p:not(:last-child) {
          margin-bottom: 20px;
        }

        p {
          span {
            margin-right: 20px;
          }
        }

        .title {
          font-size: 18px;
          color: #FFFFFF;
          font-weight: 700
        }
      }

      .app {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 14px;
        color: #FFFFFF;
        font-weight: 500;

        img {
          width: 90px;
          height: 90px;
          margin: 14px 0;
        }

        .title {
          font-size: 14px;
          color: #949498;
          font-weight: 400;
          line-height: 21px;
        }
      }
    }

    .content_bottom {
      background: #212126;
      padding: 14px 0;
      text-align: center;

      .style {
        font-size: 12px;
        color: #949498;
        font-weight: 400;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        line-height: 20px;

        span:not(:last-child) {
          margin-right: 10px;
        }
      }

      p:not(:last-child) {
        margin-bottom: 10px;
      }

      .recordsIcon {
        width: 14px;
        height: 14px;
        margin-right: 3px;
      }

      .cursor {
        cursor: pointer;
      }
    }
  }

  .footer_wrap {
    font-size: 0.2rem;
    font-family: Source Han Sans CN, Source Han Sans CN-5;
    font-weight: 400;
    text-align: left;
    color: #949498;
    line-height: 0.3rem;

    .disFlex {
      display: flex;
      flex-direction: column;
    }

    .content_top {
      padding: 0.8rem 0.29rem 0.3rem;

      .relationBox {
        margin-top: 0.2rem;
        line-height: 0.4rem;

        .title {
          font-size: 0.22rem;
          color: #FFF;
          font-weight: 700;
          margin-bottom: 0.1rem;
        }

      }

      .app {
        margin-top: 0.5rem;
        color: #FFFFFF;
        line-height: 0.4rem;

        .title {
          font-size: 0.22rem;
          color: #FFF;
          font-weight: 700;
          margin-bottom: 0.1rem;
        }

        img {
          width: 1.8rem;
          height: 1.8rem;
        }
      }
    }

    .content_bottom {
      background: #212126;
      padding: 0.3rem 0.29rem;
      line-height: 0.35rem;

      .recordsIcon {
        width: 0.14rem;
        height: 0.14rem;
        margin-right: 0.03rem;
      }

      .cursor {
        cursor: pointer;
      }
    }
  }
  .register-system-info {
    margin-right: 12px;
    color: rgb(116, 154, 227);
    cursor: pointer;
  }
  a:-webkit-any-link {
    text-decoration: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue